import {useState} from 'react';
import {Row, Col, Form, Button} from 'react-bootstrap';
import {useNavigate} from 'react-router';
import dayjs from 'dayjs';

import ConfirmModal from '../components/ConfirmModal';
import FileDisplayCard from '../components/FileDisplayCard';
import ChooseFile from '../components/ChooseFile';
import DentalBookPrivacyPolicy from '../components/DentalBookPrivacyPolicy';
import HippaNoticeOfPrivacy from '../components/HippaNoticeOfPrivacy';
import ErrorMessage from '../components/ErrorMessage';

import * as MedicalRecordApi from '../api/MedicalRecordApi';
import PageShell from '../components/PageShell';
import {problemMessage} from '../api/client';
import useIdempotencyKeys from '../hooks/useIdempotencyKeys';

export default function MedicalRecordsAdd() {
  const navigate = useNavigate();
  const keys = useIdempotencyKeys();
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [newMedicalRecord, setNewMedicalRecord] = useState({
    title: '',
    record_date: dayjs().format('YYYY-MM-DD'),
    note: '',
    medical_files: [],
  });

  const handleRemoveFile = (fileName) => {
    setNewMedicalRecord((preMedicalRecord) => ({
      ...preMedicalRecord,
      medical_files: preMedicalRecord.medical_files.filter((file) => file.file_name !== fileName),
    }));
  };

  const handleUploadFile = (newFile) => {
    setNewMedicalRecord((preMedicalRecord) => ({
      ...preMedicalRecord,
      medical_files: [...preMedicalRecord.medical_files, ...newFile],
    }));
  };

  const handleChangeForm = (e) => {
    const {name, value} = e.target;
    setNewMedicalRecord((prevMedicalRecord) => ({
      ...prevMedicalRecord,
      [name]: value,
    }));
  };

  const handleAddRecord = () => {
    keys
      .run('medical-record', newMedicalRecord, (idempotencyKey) =>
        MedicalRecordApi.createMedicalRecord(newMedicalRecord, {idempotencyKey}),
      )
      .then(() => {
        navigate('/dental-records/');
      })
      .catch((err) => {
        setErrorMessage(problemMessage(err, 'Failed to add medical record. Please try again.'));
        setIsErrorVisible(true);
        setConfirmModalShow(false);
      });
  };

  return (
    <PageShell title="Add New Records" showBackButton={true}>
      <div style={{marginTop: '1rem'}}>
        <Form>
          <Form.Group as={Row} className="mb-3" controlId="record-title">
            <Form.Label column xs="2">
              Title
            </Form.Label>
            <Col xs={10}>
              <Form.Control
                type="text"
                placeholder="A New Record Title..."
                name="title"
                value={newMedicalRecord.title}
                onChange={handleChangeForm}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3" controlId="record-date">
            <Form.Label column xs="2">
              Date
            </Form.Label>
            <Col xs={10}>
              <Form.Control
                type="date"
                name="record_date"
                value={newMedicalRecord.record_date}
                onChange={handleChangeForm}
              />
            </Col>
          </Form.Group>
          <Form.Control
            as="textarea"
            rows={10}
            aria-label="Note"
            style={{backgroundColor: '#FFF'}}
            placeholder="add some note..."
            name="note"
            value={newMedicalRecord.note}
            onChange={handleChangeForm}
          />
        </Form>
      </div>
      <div style={{padding: '0 1rem', marginTop: '1rem'}}>
        <ul className="list-style-none">
          {newMedicalRecord.medical_files.map((file, idx) => (
            <FileDisplayCard
              key={idx}
              fileName={file.file_name}
              fileLink={file.file_link}
              removeFile={handleRemoveFile}
            />
          ))}
        </ul>
        <ChooseFile height="5rem" accept="image/*,.pdf" addFile={handleUploadFile} />
        <ErrorMessage
          isVisible={isErrorVisible}
          message={errorMessage}
          onClose={() => setIsErrorVisible(false)}
        />
        <Button className="melrose-btn" onClick={() => setConfirmModalShow(true)}>
          Add Record
        </Button>
      </div>
      <ConfirmModal
        modalTitle="Disclaimer"
        show={confirmModalShow}
        btnText="Add Medical Record"
        onHide={() => setConfirmModalShow(false)}
        clickBtn={() => handleAddRecord()}
      >
        <div style={{height: '65vh', overflowX: 'auto'}}>
          <DentalBookPrivacyPolicy />
          <HippaNoticeOfPrivacy />
        </div>
      </ConfirmModal>
    </PageShell>
  );
}
